<template>
  <div id="app">
    <div class="main-wrapper">
      <div class="header-section">
        <router-link to="/" class="no-underline"><h1 class="title">DALLIN COONS</h1></router-link>
        <h2 class="sub-title sub-title-1">Test-Driven Software Engineer</h2>
        <h2 class="sub-title sub-title-2">Data Science Student @ BYU - Idaho</h2>
        <div class="resume-button-wrapper hvr-sweep-to-right lg-screen-resume">
          <a class="resume-text" href="/dallin-coons-resume.pdf" target="_blank">Resume</a>
        </div>
      </div>
      <router-view></router-view>
      <div class="social-links-wrapper">
        <a class="icon-link" href="https://github.com/dallincoons" target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.58 31.77">
            <title>github-icon</title>
            <path class="cls-blue-github" d="M16.29,0a16.29,16.29,0,0,0-5.15,31.75c.82.15,1.11-.36,1.11-.79s0-1.41,0-2.77C7.7,29.18,6.74,26,6.74,26a4.36,4.36,0,0,0-1.81-2.39c-1.47-1,.12-1,.12-1a3.43,3.43,0,0,1,2.49,1.68,3.48,3.48,0,0,0,4.74,1.36,3.46,3.46,0,0,1,1-2.18c-3.62-.41-7.42-1.81-7.42-8a6.3,6.3,0,0,1,1.67-4.37,5.94,5.94,0,0,1,.16-4.31s1.37-.44,4.48,1.67a15.41,15.41,0,0,1,8.16,0c3.11-2.11,4.47-1.67,4.47-1.67A5.91,5.91,0,0,1,25,11.07a6.3,6.3,0,0,1,1.67,4.37c0,6.26-3.81,7.63-7.44,8a3.85,3.85,0,0,1,1.11,3c0,2.18,0,3.94,0,4.47s.29.94,1.12.78A16.29,16.29,0,0,0,16.29,0Z"/>
          </svg>
        </a>
        <a class="icon-link" href="https://www.linkedin.com/in/dallin-coons-784a6b34/" target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38.06 38.06">
            <title>linkedin-logo-unfilled</title>
            <path class="cls-linkedin-circle-blue" d="M19,0A19,19,0,0,0,0,19H0a19,19,0,0,0,38.06,0h0A19,19,0,0,0,19,0ZM14.34,27.51H10.4V14.79h3.94Zm-2-14.39a2.35,2.35,0,1,1,2.33-2.35A2.34,2.34,0,0,1,12.35,13.12ZM29.1,27.51H25.18V20.83C25.18,19,24.48,18,23,18s-2.4,1.06-2.4,2.85v6.68H16.86V14.79h3.78V16.5a4.42,4.42,0,0,1,3.83-2.1c2.7,0,4.63,1.65,4.63,5.06Z"/>
          </svg>
        </a>
        <a class="icon-link" href="https://twitter.com/goodsoftnuggets" target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38.06 38.06">
            <title>twitter-logo-unfilled</title>
            <path class="cls-twitter-cricle-blue" d="M19,0A19,19,0,0,0,0,19H0a19,19,0,0,0,38.06,0h0A19,19,0,0,0,19,0Zm8.06,14.89A11.83,11.83,0,0,1,8.89,25.4a8.37,8.37,0,0,0,6.16-1.72,4.18,4.18,0,0,1-3.89-2.89A4.22,4.22,0,0,0,13,20.72a4.16,4.16,0,0,1-3.33-4.13,4.26,4.26,0,0,0,1.88.52,4.18,4.18,0,0,1-1.29-5.56,11.79,11.79,0,0,0,8.58,4.35A4.17,4.17,0,0,1,26,12.1a8.13,8.13,0,0,0,2.64-1,4.17,4.17,0,0,1-1.83,2.31,8.39,8.39,0,0,0,2.39-.66A8.18,8.18,0,0,1,27.09,14.89Z"/>
          </svg>
        </a>
        <div class="email-line"></div>
      </div>
      <div class="email-wrapper">
        <a href="mailto: dallincoons@gmail.com" target="_blank">dallincoons@gmail.com</a>
        <div class="email-line"></div>
      </div>
      <footer>
        <div class="icon-wrapper">
          <a class="icon-link" href="https://github.com/dallincoons" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.58 31.77">
              <title>github-icon</title>
              <path class="cls-github" d="M16.29,0a16.29,16.29,0,0,0-5.15,31.75c.82.15,1.11-.36,1.11-.79s0-1.41,0-2.77C7.7,29.18,6.74,26,6.74,26a4.36,4.36,0,0,0-1.81-2.39c-1.47-1,.12-1,.12-1a3.43,3.43,0,0,1,2.49,1.68,3.48,3.48,0,0,0,4.74,1.36,3.46,3.46,0,0,1,1-2.18c-3.62-.41-7.42-1.81-7.42-8a6.3,6.3,0,0,1,1.67-4.37,5.94,5.94,0,0,1,.16-4.31s1.37-.44,4.48,1.67a15.41,15.41,0,0,1,8.16,0c3.11-2.11,4.47-1.67,4.47-1.67A5.91,5.91,0,0,1,25,11.07a6.3,6.3,0,0,1,1.67,4.37c0,6.26-3.81,7.63-7.44,8a3.85,3.85,0,0,1,1.11,3c0,2.18,0,3.94,0,4.47s.29.94,1.12.78A16.29,16.29,0,0,0,16.29,0Z"/>
            </svg>
          </a>
          <a class="icon-link" href="https://www.linkedin.com/in/dallin-coons-784a6b34/" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38.06 38.06">
              <title>linkedin-logo-unfilled</title>
              <path class="cls-linkedin-circle" d="M19,0A19,19,0,0,0,0,19H0a19,19,0,0,0,38.06,0h0A19,19,0,0,0,19,0ZM14.34,27.51H10.4V14.79h3.94Zm-2-14.39a2.35,2.35,0,1,1,2.33-2.35A2.34,2.34,0,0,1,12.35,13.12ZM29.1,27.51H25.18V20.83C25.18,19,24.48,18,23,18s-2.4,1.06-2.4,2.85v6.68H16.86V14.79h3.78V16.5a4.42,4.42,0,0,1,3.83-2.1c2.7,0,4.63,1.65,4.63,5.06Z"/>
            </svg>
          </a>
          <a class="icon-link" href="https://twitter.com/goodsoftnuggets" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38.06 38.06">
              <title>twitter-logo-unfilled</title>
              <path class="cls-twitter-cricle" d="M19,0A19,19,0,0,0,0,19H0a19,19,0,0,0,38.06,0h0A19,19,0,0,0,19,0Zm8.06,14.89A11.83,11.83,0,0,1,8.89,25.4a8.37,8.37,0,0,0,6.16-1.72,4.18,4.18,0,0,1-3.89-2.89A4.22,4.22,0,0,0,13,20.72a4.16,4.16,0,0,1-3.33-4.13,4.26,4.26,0,0,0,1.88.52,4.18,4.18,0,0,1-1.29-5.56,11.79,11.79,0,0,0,8.58,4.35A4.17,4.17,0,0,1,26,12.1a8.13,8.13,0,0,0,2.64-1,4.17,4.17,0,0,1-1.83,2.31,8.39,8.39,0,0,0,2.39-.66A8.18,8.18,0,0,1,27.09,14.89Z"/>
            </svg>
          </a>
          <a class="icon-link" href="mailto: dallincoons@gmail.com">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
              <title>email-icon</title>
              <polygon class="cls-email-icon" points="14.05 18.55 14.05 29.45 19.5 24 14.05 18.55"/>
              <path class="cls-email-icon" d="M27.27,26.72a3.55,3.55,0,0,1-5,0l-1.05-1-5.45,5.45h18l-5.45-5.45Z"/>
              <path class="cls-email-icon" d="M25.59,25l8.17-8.17h-18L23.91,25A1.18,1.18,0,0,0,25.59,25Z"/>
              <path class="cls-email-icon" d="M24,0h0A24,24,0,0,0,0,24H0A24,24,0,0,0,24,48h0A24,24,0,0,0,48,24h0A24,24,0,0,0,24,0ZM37.82,29.94a3.57,3.57,0,0,1-3.56,3.57h-19a3.57,3.57,0,0,1-3.56-3.57V18.06a3.57,3.57,0,0,1,3.56-3.57h19a3.57,3.57,0,0,1,3.56,3.57Z"/>
              <polygon class="cls-email-icon" points="35.45 29.45 35.45 18.55 30 24 35.45 29.45"/>
            </svg>
          </a>
        </div>
        <div class="resume-button-wrapper">
          <a class="resume-text" href="/dallin-coons-resume.pdf" target="_blank">Resume</a>
        </div>
        <p class="footer-info">Designed and coded by <a href="http://emilydcoons.com" target="_blanks">Emily</a></p>
      </footer>
    </div>

  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style>
#app {
  font-family: ibm-plex-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
}

html, body {
  max-width: 100%;
  overflow-x: hidden;
  background: rgba(240,246,255,.3);
}
.main-wrapper {
  padding: 1rem;
  position: relative;
  width: 1000px;
  margin: 0 auto;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.header-section {
  display: grid;
  grid-template-columns: 1fr .15fr;
  grid-template-rows: auto;
  margin-top: 4rem;
}

.title {
  color: #10abd1;
  font-size: 60px;
  line-height: 55px;
  font-weight: 700;
  margin: 0;
  margin-bottom: .2rem;
}

.no-underline {
  text-decoration: none;
}

.sub-title {
  margin: 0;
  font-size: 16px;
  font-weight: 300;
}

.sub-title-1 {
  grid-row: 2;
  margin-bottom: .3rem;
}

.sub-title-2 {
  grid-row: 3;
}

.icon-wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px;
  justify-items: center;
}

.icon-link {
  display: flex;
  justify-content: center;
}

.resume-button-wrapper {
  border: 2px solid #0d0d0d;
  margin-top: 1rem;
  padding: 1rem 2rem;
  text-transform: uppercase;
  font-weight: 600;
  text-align: center;
}



.resume-text {
  color: #0D0D0D;
  font-weight: 700;
  text-decoration: none;
}

.hvr-sweep-to-right {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  position: relative;
  -webkit-transition-property: color;
  transition-property: color;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
}
.hvr-sweep-to-right:before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #10abd1;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transform-origin: 0 50%;
  transform-origin: 0 50%;
  -webkit-transition-property: transform;
  transition-property: transform;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}
.hvr-sweep-to-right:hover, .hvr-sweep-to-right:focus, .hvr-sweep-to-right:active {
  color: white;
}
.hvr-sweep-to-right:hover:before, .hvr-sweep-to-right:focus:before, .hvr-sweep-to-right:active:before {
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
}

.cls-github{fill:#0D0D0D;
  fill-rule:evenodd;}
.cls-blue-github{fill:#01ABD1;
  fill-rule:evenodd;}
.cls-blue-web{fill:#01ABD1;}
.cls-linkedin-circle{fill:#0D0D0D;}
.cls-linkedin-circle-blue{fill:#01ABD1;}
.cls-twitter-cricle{fill:#0D0D0D;}
.cls-twitter-cricle-blue{fill:#01ABD1;}
.cls-email-icon{fill: #0D0D0D}

.icon-wrapper svg {
  width: 60%;
}



footer {
  display: none;
}

.social-links-wrapper {
  position: fixed;
  left: -100px;
  bottom: 0;
  transform: rotate(90deg);
  display: flex;
  align-items: center;
}

.icon-link {
  display: inline-block;
  width: 25px;
  height: 25px;
  margin-right: 1rem;
}

.icon-link svg{
  width: 100%;
  transform: rotate(-90deg);
  transition: all .2s ease-in-out;
}
.icon-link:hover svg{
  transform: rotate(-90deg) translateY(-3px);
  transition: all .2s ease-in-out;
}

.icon-link:hover svg path {
  fill: #0D0D0D;
  transition: all .2s ease-in-out;
}

.email-wrapper {
  position: fixed;
  right: -100px;
  bottom: 0;
  transform: rotate(90deg);
  display: flex;
  align-items: center;
}

.email-wrapper a {
  color: #10abd1;
  text-decoration: none;
  font-weight: 700;
  transition: all .2s ease-in-out;
}

.email-wrapper:hover a {
  color: #0d0d0d;
  transform: translateX(-3px);
  transition: all .2s ease-in-out;
}

.email-line {
  width: 500px;
  height: 4px;
  background: #10abd1;
  margin-left: 1rem;
}

@media (max-width: 1500px) {
  .social-links-wrapper {
    left: -200px;
  }
}

@media (min-width: 1199px) and (max-width: 1400px) {
  .social-links-wrapper {
    left: -250px;
  }

  .email-wrapper {
    right: -250px;
  }
}

@media (max-width: 1200px) {
  .main-wrapper {
    width: 800px;
  }

  .social-links-wrapper {
    left: -300px;
  }

  .email-wrapper {
    right: -300px;
  }
}

@media (max-width: 900px) {
  .main-wrapper {
    width: 70%;
  }

  .title {
    font-size: 60px;
    line-height: 55px;
    font-weight: 700;
    margin: 0;
    margin-bottom: 1rem;
    margin-left: -1rem;
    transform: rotate(-6deg);
    color: #0d0d0d;
  }

  .sub-title {
    margin: 0;
    font-size: 16px;
    transform: rotate(-6deg);
  }

  .lg-screen-resume {
    display: none;
  }
  .email-wrapper, .social-links-wrapper {
    display: none;
  }

  .icon-link svg{
    transform: rotate(0);
  }

  footer {
    margin-top: 2rem;
    padding: 1rem 0;
    display: grid;
    grid-template-columns: 1fr .25fr;
    grid-template-rows: 1fr 1fr;
    align-items: center;
    grid-gap: 10px;
    border-top: 8px solid #10abd1;
    transform: rotate(-4deg);
  }
  .footer-info {
    font-style: italic;
    font-size: 12px;
    text-align: center;
    margin-top: 1rem;
    grid-column: 1 / span 2;
  }
  .footer-info a {
    color: #0D0D0D;
    font-weight: 700;
    text-decoration: none;
  }

  .icon-link {
    width: 40px;
    height: 40px;
    margin: 0;
  }

  .resume-button-wrapper {
    margin-top: 0;
  }
}

@media (max-width: 500px) {
  .main-wrapper {
    width: 85%;
  }

  footer {
    grid-template-rows: repeat(3, 1fr);
    grid-template-columns: 1fr;
  }

  .resume-button-wrapper {
    grid-row: 2;
  }
}
</style>
